var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reportName)?_c('v-col',{attrs:{"cols":"12","sm":"6","md":"7","lg":"8","xl":"9"}},[_c(_vm.currentReportComponent,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }